import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { PiasLayoutComponent } from '../../../shared/components/pias-layout/pias-layout.component';
import { MatCardModule } from '@angular/material/card';
import { RmAssessmentComponent } from '../rm-assessment/rm-assessment.component';
import { NewRepChecklistComponent } from '../new-rep-checklist/new-rep-checklist.component';
import { NewRepApplicationPage } from '../new-rep-application/new-rep-application/new-rep-application.page';
import { MatIcon } from '@angular/material/icon';
import { IntroducerFormIndividualComponent } from '../new-introducer/introducer-form-individual/introducer-form-individual.component';
import { IntroducerFormCorporateComponent } from '../new-introducer/introducer-form-corporate/introducer-form-corporate.component';
import { NewIntroducerChecklist } from '../new-introducer-checklist/new-introducer-checklist';
import { IntroducerRepAssessmentComponent } from '../introducer-rep-assessment/introducer-rep-assessment.component';
import { OnboardingComments } from '../onboarding-comments/onboarding-comments';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { OnboardingCommentsService } from '../onboarding-comments/onboarding-comments-service/onboarding-comments.service';
import { Router } from '@angular/router';
import { HttpStatusCode } from 'axios';
import { ViewOnboardingcomments } from '../onboarding-comments/onboarding-comments-interface/view-onboardingcomments.interface';

@Component({
  selector: 'app-agent-onboarding-navigation',
  imports: [
    CommonModule,
    MatTabsModule,
    PiasLayoutComponent,
    MatCardModule,
    MatTabGroup,
    NewRepApplicationPage,
    RmAssessmentComponent,
    NewRepChecklistComponent,
    MatIcon,
    IntroducerFormIndividualComponent,
    IntroducerFormCorporateComponent,
    IntroducerRepAssessmentComponent,
    NewIntroducerChecklist,
    OnboardingComments,
  ],
  standalone: true,
  templateUrl: './agent-onboarding-navigation.component.html',
  styleUrl: './agent-onboarding-navigation.component.scss'
})
export class AgentOnboardingNavigationComponent implements OnInit {
  @ViewChild('RmTabs') tabGroup!: MatTabGroup;
  protected selectedTabId: string = "";
  private snackBarService = inject(SnackbarService);
  private onboardingCommentsService = inject(OnboardingCommentsService);
  private router = inject(Router);
  selectedIndex: number = 0;
  data = history.state;
  status!: string;
  readonly = signal(false);
  designation!: string;
  onboardingComments!: string;
  dsuComments!: string;
  viewId!: number;
  viewReturnComments!: ViewOnboardingcomments[];



  totalTabs: number = 3;
  constructor() { }
  ngOnInit(): void {

    this.status = this.data.status;
    this.designation = this.data.designation;
    this.readonly.set(this.data.isReadOnly);
    if (this.status != 'Candidate Submission') {
      this.selectedTabId = "new-repapplication";
    }
    this.viewId = this.data.id;
    this.status = this.data.status;

    this.getreturnComments();

  }

  protected __onAgentOnboardingTabChange(event: MatTabChangeEvent) {
    if (event.tab.id) {
      this.selectedTabId = event.tab.id.toString();
    }
    else {
      console.error(`Invalid tab ID for mat-tab[${event.index}]`);
    }
  }

  protected nextTab(): void {
    if (this.selectedIndex < this.totalTabs - 1) {
      this.selectedIndex++; // ✅ This automatically switches tab
    }
  }

  async getreturnComments() {
    const responseData = await this.onboardingCommentsService
      .returnComments(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    if (responseData.status === HttpStatusCode.Ok) {
      this.viewReturnComments = responseData.data.responsedata;
      this.viewReturnComments.forEach((item) => {
        if (this.status == 'Candidate Update (Due Diligence)') {
          if (item.status == 'Onboarding Processing') {
            this.onboardingComments = item.remarkContent
          }
        }
        if (this.status == 'Candidate Update (Assessment)') {
          if (['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)) {
            if (item.status == 'DSU Final Assessment') {
              this.onboardingComments = item.remarkContent
            }
          }
          else {
            if (item.status == 'DSU Initial Assessment') {
              this.onboardingComments = item.remarkContent
            }
          }
        }
      });
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }
}


